module.exports = __webpack_public_path__ + "img/feedback.087209b4.svg";